import React from "react";
import classNames from "classnames/bind";

function DropDownMenu({ children, customClassName }) {
  const dropdownClasses = classNames({
    dropdownMenu: true,
    [customClassName]: customClassName,
  });

  return <section className={dropdownClasses}>{children}</section>;
}

export default DropDownMenu;
